import { useMemo } from 'react';

const ONBOARDING_SOURCE_META_COMPANY_LIST =
	process.env.REACT_APP_ONBOARDING_SOURCE_META_COMPANY_LIST;

/**
 * Currently on supports Todd but this util checks if the companyId is featured flagged
 * This will enable features for specific companies
 * such as EPR, modals for syncs, etc.
 * @param {number} companyId
 * @returns {boolean}
 */
export const isFeatureFlagCompany = (companyId) => {
	if (!ONBOARDING_SOURCE_META_COMPANY_LIST) return false;
	if (!companyId) return false;
	try {
		const parsedMetaCompanyList = JSON.parse(
			ONBOARDING_SOURCE_META_COMPANY_LIST
		);

		return parsedMetaCompanyList.includes(companyId);
	} catch (e) {
		return false;
	}
};

/**
 *
 * @param {number} companyId
 * @returns {boolean}
 */
export const useIsFeatureFlagCompany = (companyId) =>
	useMemo(() => isFeatureFlagCompany(companyId), [companyId]);
